import pendingIcon from 'static/images/status/pending.png';
import rejectIcon from 'static/images/status/reject.png';
import successIcon from 'static/images/status/success.png';

export type StatusType = 'PENDING' | 'SUCCESS' | 'REJECTED';

type ResultConfigType = Record<
    StatusType,
    {
        img: string | React.ReactElement;
        content: string;
        btnText: string;
    }
>;

const btnText = __('返回个人中心');

// 设计稿参考: https://www.figma.com/design/H6McXECM9DigsKvhuFvPFp/Web%3AH5-%E7%BB%84%E4%BB%B6-%E6%96%B0?node-id=0-3178&m=dev
const ResultPageConfig: ResultConfigType = {
    PENDING: {
        img: pendingIcon,
        content: __('正在审核中'),
        btnText: btnText
    },
    SUCCESS: {
        img: successIcon,
        content: __('审核已通过'),
        btnText: btnText
    },
    REJECTED: {
        img: rejectIcon,
        content: __('审核被拒绝'),
        btnText: btnText
    }
};

export default ResultPageConfig;
